import { render, staticRenderFns } from "./VTableBody.vue?vue&type=template&id=8c326910&scoped=true&lang=pug"
import script from "./VTableBody.vue?vue&type=script&lang=js"
export * from "./VTableBody.vue?vue&type=script&lang=js"
import style0 from "./VTableBody.vue?vue&type=style&index=0&id=8c326910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c326910",
  null
  
)

export default component.exports